'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';

function createChangeHandler(changeCallback, key) {
  return newValue => changeCallback(key, newValue);
} // High-order component to create a consistent API for adding form fields
// to the dialog.


export default function createFormField(WrappedComponent, key, defaultValue = undefined) {
  function FormField(_ref) {
    let {
      onChange,
      value
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["onChange", "value"]);

    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
      value: value,
      onChange: createChangeHandler(onChange, key)
    }, rest), key);
  }

  FormField.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired
  };
  FormField.key = key;
  FormField.defaultValue = defaultValue;
  return FormField;
}